import { EditOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import PropTypes from 'prop-types';
import React, { memo } from 'react';

const FieldPasswordTag = ({ onClick }) => {
  return (
    <Tag color="green" className="w-full pb-0.5 pt-2 flex items-center justify-between">
      <div className="text-2xl">
        ********
      </div>
      <EditOutlined className="float-right cursor-pointer text-lg mr-2" onClick={onClick}/>
    </Tag>
  );
  
};

FieldPasswordTag.propTypes = {
  onClick: PropTypes.func
};

FieldPasswordTag.defaultProps = {};

export default memo(FieldPasswordTag);
